import { goalCardStrings } from "@/features/studies/creation/components/goals/strings";
import i18n from "@/i18n";

/**
 * The study-type pill the lobby, the report hero and Review show: the goal's
 * `methodTag`, the same label as the goal's card and its creation chip, and
 * "Custom" for a study with no known goal. Explore keeps its own colour.
 */
export function getStudyTypeMeta(goalId?: string | null): { label: string; className: string } {
  const goal = goalId
    ? goalCardStrings[goalId as keyof typeof goalCardStrings]
    : undefined;
  if (!goal) {
    return { label: i18n.t("studyLobby.custom", { ns: "app" }), className: "border-border/70 bg-background/85 text-muted-foreground" };
  }
  return {
    label: goal.methodTag,
    className:
      goalId === "explore"
        ? "border-emerald-200 bg-emerald-50 text-emerald-800"
        : "border-sky-200 bg-sky-50 text-sky-800",
  };
}

/**
 * True when `goalId` is "explore" or a key of `goalCardStrings`. Used by the
 * report hero to decide whether to render a pill at all: unlike the lobby,
 * the hero never falls back to "Custom" for a null or unknown goal.
 */
export function isKnownStudyGoal(goalId?: string | null): boolean {
  if (!goalId) {
    return false;
  }
  return goalId === "explore" || goalId in goalCardStrings;
}
